/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * gray
 */
const lightGray = '#D3D3D3'
const darkGray = '#A9A9A9'
const x11Gray = '#BEBEBE'
const htmlGray = '#808080'
const MAIN_APP_BACKGROUND_COLOR = '#F5F6F7'

/**
 * Table colors
 */
const tableHeaderGray = '#CFCFCF'
const tableStripedRowDark = '#FAFAFA'
const tableStripedRowLight = '#FFFFFF'
const tableButtonGray = '#707071'

/**
 * blue
 */
const baseBlue = '#0072CE'
const headerGray = 'GreyText'

const ARGOS_GREEN = '#0d880d'
const ARGOS_PENDING_COLOR = '#6CC4C8'
const ARGOS_PROGRESS_COLOR = baseBlue
const ARGOS_WARNING = '#FFA500'
const ARGOS_ERROR = '#FF0000'
enum EArgosReportsState {
  OK = 'OK',
  PENDING = 'PENDING',
  MODIFIED = 'MODIFIED',
  DELETED = 'DELETED',
  FAILED = 'FAILED',
  IN_PROGRESS = "IN PROGRESS"
}
const ARGOS_REPORTS_STATE_TO_COLOR: any = {
  [EArgosReportsState.OK]: ARGOS_GREEN,
  [EArgosReportsState.PENDING]: ARGOS_WARNING,
  [EArgosReportsState.MODIFIED]: ARGOS_WARNING,
  [EArgosReportsState.DELETED]: ARGOS_ERROR,
  [EArgosReportsState.FAILED]: ARGOS_ERROR,
  [EArgosReportsState.IN_PROGRESS]: ARGOS_PROGRESS_COLOR
}

export {
  lightGray,
  darkGray,
  x11Gray,
  htmlGray,
  tableHeaderGray,
  MAIN_APP_BACKGROUND_COLOR,

  tableStripedRowDark,
  tableStripedRowLight,
  tableButtonGray,
  baseBlue,
  headerGray,
  ARGOS_GREEN,
  ARGOS_WARNING,
  ARGOS_ERROR,
  EArgosReportsState,
  ARGOS_REPORTS_STATE_TO_COLOR,
  ARGOS_PENDING_COLOR,
  ARGOS_PROGRESS_COLOR
}
